"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_SURVEY_DROP = exports.SURVEY_DROP_LIST = exports.SURVEY_TYPE = void 0;
exports.SURVEY_TYPE = {
    OBJECTIVE: 'choice',
    SHORT_ANSWER: 'short',
    LONG_ANSWER: 'long',
    CHECKBOX: 'checkbox',
};
exports.SURVEY_DROP_LIST = [
    { id: exports.SURVEY_TYPE.OBJECTIVE, title: '객관식' },
    { id: exports.SURVEY_TYPE.SHORT_ANSWER, title: '단답형' },
    { id: exports.SURVEY_TYPE.LONG_ANSWER, title: '장문형' },
    { id: exports.SURVEY_TYPE.CHECKBOX, title: '체크형' },
];
exports.DEFAULT_SURVEY_DROP = { id: exports.SURVEY_TYPE.CHECKBOX, title: '체크형' };
